import React from 'react';
import { connect } from 'react-redux';
import { SCORE_TYPE, SCORE_NAME } from '~/utils/constant';
import css from './Card.less';

const noContentIcon = require('~/static/common/no_content.png');

const Card = props => {
  const { institution } = props;
  const { shop } = institution;
  return (
    <div className={css.contentMain}>
      <p className={css.title}>{shop.name}</p>

      {/* 评分汇总 */}
      {shop.total_score ? (
        <>
          <div className={css.scoreSummary}>
            <div className={`${css.score} dinMedium`}>
              {shop.total_score || 0}
            </div>
            <div className={css.scoreDetail}>
              <p className={css.title}>用户评分</p>
              <div className={css.scoreInfo}>
                {shop.max_score && shop.min_score && (
                  <>
                    <p className={css.scoreInfoItem}>
                      <span>最高分：{shop.max_score.name}</span>
                      <span className={`${css.scoreNum} dinMedium`}>
                        {shop.max_score.score}
                      </span>
                    </p>
                    <p className={css.scoreInfoItem}>
                      <span>最低分：{shop.min_score.name}</span>
                      <span className={`${css.scoreNum} dinMedium`}>
                        {shop.min_score.score}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* 评分明细 */}
          <ul className={css.scoreBox}>
            {Object.keys(SCORE_TYPE).map(key => {
              return (
                <li className={css.scoreItem} key={key}>
                  <p className={css.scoreTitle}>{SCORE_NAME[key]}</p>
                  <div className={css.scoreShow}>
                    <div className={css.progress}>
                      <span
                        style={{
                          width: `${(shop.avg_score[SCORE_TYPE[key]] / 10) *
                            270}px`,
                        }}
                      >
                        {' '}
                      </span>
                    </div>
                    <p className={`${css.scoreNum} dinMedium`}>
                      {shop.avg_score[SCORE_TYPE[key]]}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </>
      ) : (
        <div className={css.noContent}>
          <img src={noContentIcon} alt="noContentIcon" className={css.icon} />
          <p className={css.msg}>尚未收集到足够多的用户评分</p>
        </div>
      )}
    </div>
  );
};

export default connect(({ institution }) => ({
  institution,
}))(Card);
